import * as React from 'react';
import cx from 'classnames';
import styles from './index.less';
import { observer } from 'mobx-react';
import { noop } from '@src/utils/common-util';
import Link from '@src/components/link';
// closeBtn  closeBtnDlc
const CloseBtn = ({ onClose = noop, className, ...rest }) => {
  return (
    <Link
      className={cx(className, styles.closeBtnDlc)}
      onClick={() => {
        onClose();
      }}
      {...rest}
    />
  );
};

export default observer(CloseBtn);
